<template>
  <svg
    viewBox="0 0 14 14"
    xmlns="http://www.w3.org/2000/svg"
    width="14"
    height="14"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M4.63128 7.61872C4.28957 7.27701 4.28957 6.72299 4.63128 6.38128L8.13128 2.88128C8.47299 2.53957 9.02701 2.53957 9.36872 2.88128C9.71043 3.22299 9.71043 3.77701 9.36872 4.11872L6.48744 7L9.36872 9.88128C9.71043 10.223 9.71043 10.777 9.36872 11.1187C9.02701 11.4604 8.47299 11.4604 8.13128 11.1187L4.63128 7.61872Z"
    />
  </svg>
</template>
